import { injectIntl } from 'react-intl';

import PaginationComponent from './PaginationComponent';

export default injectIntl(PaginationComponent);
